import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// 🔥 Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBo_zbAbVyfAoxyKTT_sXCuthDwuME-dw4",
  authDomain: "iberpisos-c3162.firebaseapp.com",
  projectId: "iberpisos-c3162",
  storageBucket: "iberpisos-c3162.appspot.com",
  messagingSenderId: "90917078408",
  appId: "1:90917078408:web:fcc2e1e950403a8bc9263d",
};

// 🔥 Inicializa Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

// ✅ Solo exportamos `storage` porque `db` se exporta en las demás páginas
export { storage };
